import {Component, Input} from '@angular/core';
import {RequestConfirmationHelperObject} from '../../../model/RequestConfirmationHelperObject';
import {Router} from '@angular/router';
import {RequestMetadata} from '../../../generate/RequestMetadata';
import {RequestType} from "../../../model/RequestType";

@Component({
    selector: 'submit-confirmation',
    templateUrl: './submit-confirmation.component.html',
    styleUrls: ['./submit-confirmation.component.scss'],
    standalone: false
})
export class SubmitConfirmationComponent {

  @Input()
  requestConfirmation: RequestConfirmationHelperObject;

  @Input()
  deleteRequest: boolean;

  @Input()
  domainName: string;

  @Input()
  newDelegation: boolean;

  @Input()
  showTicketNumber: boolean;

  @Input()
  requestMetadata: RequestMetadata;


  @Input()
  updateChangeRequest: boolean;

  DIRECT = RequestType.DIRECT;

  constructor(private router: Router) {
  }

  goToHome() {
    this.router.navigateByUrl('/user/home');
  }

}
